<script setup>

const props = defineProps({
  errors: "",
  showBackendError: Boolean,
});
</script>

<template>
  <div>
    <div v-if="showBackendError">
      <i18n-t keypath="appErrors.backendCommunicationError" tag="p" scope="global">
        <template v-slot:supportLink>
          <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('supportLink')">{{ $t("support") }}</a>
        </template>
      </i18n-t>
    </div>
    <div v-else>
      <i18n-t keypath="offerForm.errorModal.text" tag="p" scope="global">
        <template v-slot:supportLink>
          <a class="text-primary" target="_blank" rel="noreferrer noopener nofollow" :href="$t('supportLink')">{{ $t("support") }}</a>
        </template>
      </i18n-t>
    </div>
    <div v-for="error in errors">
      <p v-if="error.code">
        {{ $t("offerForm.errorModal.errorCode") }}: {{ error.code }}
      </p>
    </div>
  </div>
</template>
